import Icon from '@/components/ui/AppIcon';

export default function MedicalDisclaimer() {
  return (
    <section className="py-12 bg-warning/10 border-y border-warning/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-warning/20 flex items-center justify-center flex-shrink-0">
              <Icon name="ExclamationTriangleIcon" size={24} className="text-warning" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-foreground mb-3">
                Important Medical Information
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                This information is for educational purposes only and should not be considered medical advice. Always consult with a qualified healthcare provider before starting any new treatment or medication. Individual results may vary, and treatment effectiveness depends on various factors including medical history, lifestyle, and adherence to prescribed regimens.
              </p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                All products are prescribed by licensed physicians after a thorough medical evaluation. By proceeding with a purchase, you acknowledge that you have read and understood this disclaimer and agree to our Terms of Service and Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}